import { cloneDeep } from 'lodash';
import { transformOpRange } from '../transformCursor';
import { defineTransform } from '../transform';

function transformSetSelectionOp(selectionOp, op) {
  let tOp = cloneDeep(selectionOp);
  tOp = transformOpRange(selectionOp, 'properties', op);
  tOp = transformOpRange(tOp, 'newProperties', op);
  return tOp;
}

defineTransform('set_selection', 'insert_text', (op1, op2, side) =>
  transformSetSelectionOp(op1, op2)
);

defineTransform('set_selection', 'remove_text', (op1, op2, side) =>
  transformSetSelectionOp(op1, op2)
);

defineTransform('set_selection', 'split_node', (op1, op2, side) =>
  transformSetSelectionOp(op1, op2)
);

defineTransform('set_selection', 'merge_node', (op1, op2, side) =>
  transformSetSelectionOp(op1, op2)
);

defineTransform('set_selection', 'move_node', (op1, op2, side) =>
  transformSetSelectionOp(op1, op2)
);

defineTransform('set_selection', 'insert_node', (op1, op2, side) =>
  transformSetSelectionOp(op1, op2)
);

defineTransform('set_selection', 'remove_node', (op1, op2, side) =>
  transformSetSelectionOp(op1, op2)
);

defineTransform('set_selection', 'set_node', (op1, op2, side) => op1);
defineTransform('set_selection', 'add_mark', (op1, op2, side) => op1);
defineTransform('set_selection', 'remove_mark', (op1, op2, side) => op1);
defineTransform('set_selection', 'set_mark', (op1, op2, side) => op1);
defineTransform('set_selection', 'add_annotation', (op1, op2, side) => op1);
defineTransform('set_selection', 'remove_annotation', (op1, op2, side) => op1);
defineTransform('set_selection', 'set_annotation', (op1, op2, side) => op1);
defineTransform('set_selection', 'set_selection', (op1, op2, side) => op1);
defineTransform('set_selection', 'add_metadata', (op1, op2, side) => op1);
defineTransform('set_selection', 'remove_metadata', (op1, op2, side) => op1);
defineTransform('set_selection', 'set_metadata', (op1, op2, side) => op1);
